import fsPromises from "fs/promises"
import { GetStaticPropsContext, GetStaticPropsResult, NextPage } from "next"
import path from "path"
import {
  ArticleDetailType,
  BlogBreadcrumbs,
  getBlogArticlePath,
  getMetaDescriptionBlog,
  getMetaTitleBlog,
} from "@/components/Blog"
import { ALIASES, articles } from "@/components/Blog/mock"
import { Article, ArticlePost } from "@/components/Blog/StyledBlog"
import { Meta } from "@/components/Meta/Meta"
import { BlogTemplate } from "@/layouts/Blog/BlogTemplate"
import { getSecondsDay } from "@/utils/common/helpers"

type ArticleSSRType = {
  article: ArticleDetailType
}

export const getStaticPaths = () => {
  const paths = Object.values(ALIASES).map((alias) => ({
    params: {
      article: alias,
    },
  }))

  return {
    paths: paths,
    fallback: false, // false or "blocking" or true
  }
}

export const getStaticProps = async (
  ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<ArticleSSRType>> => {
  const { params } = ctx
  const articleAlias = (params?.article as string) || ""

  if (!articleAlias) {
    return {
      notFound: true,
    }
  }

  const articleData = articles[articleAlias]

  if (!articleData || !articleData.contentPath) {
    return {
      notFound: true,
    }
  }

  const filePath = path.join(process.cwd(), articleData.contentPath)
  const jsonData = await fsPromises.readFile(filePath, "utf-8")

  return {
    props: {
      article: { ...articleData, content: jsonData },
    },
    revalidate: getSecondsDay(7),
  }
}

const TypesPackagingBlogPage: NextPage<ArticleSSRType> = ({ article }) => {
  const { alias, content, title, description } = article

  const breadcrumbPage = {
    title: title,
    path: getBlogArticlePath(alias),
  }

  return (
    <>
      <Meta
        title={getMetaTitleBlog(title)}
        description={getMetaDescriptionBlog(description)}
        ogTags={{
          title,
          description,
        }}
      />
      <BlogTemplate>
        <Article>
          <BlogBreadcrumbs breadcrumb={breadcrumbPage} />
          {!!content && (
            <ArticlePost
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          )}
        </Article>
      </BlogTemplate>
    </>
  )
}

export default TypesPackagingBlogPage
